import * as React from 'react'
import { UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as Style from './style.css'
import CheckIcon from './icon_check.svg?reactCompornt'
import { TimePicker } from '~/atoms/search/TimePicker'

interface IProps {
  register: UseFormRegister<ISearchRegularState>
  weeks: string[]
  watch: UseFormRegister<ISearchRegularState>
  setWeekHandler: (week: WeekType, value: number) => void
  setWorkTimeFromHandler: (week: WeekType, value: string) => void
  setWorkTimeFromUnselectedHandler: (week: WeekType, value: number) => void
  setWorkTimeToHandler: (week: WeekType, value: string) => void
  setWorkTimeToUnselectedHandler: (week: WeekType, value: number) => void
  isSearchDisable: boolean
}

const DEFAULT_START_HOUR = '12'
const DEFAULT_START_MINUTE = '00'
const DEFAULT_END_HOUR = '13'
const DEFAULT_END_MINUTE = '00'

export const SearchConditionRegularLeftNavi = ({
  watch,
  weeks,
  setWeekHandler,
  setWorkTimeFromHandler,
  setWorkTimeFromUnselectedHandler,
  setWorkTimeToHandler,
  setWorkTimeToUnselectedHandler,
  register,
  isSearchDisable,
}: IProps): JSX.Element => {
  const { t } = useTranslation()
  const buttonStyle = isSearchDisable
    ? Style.SearchButtonDisabled
    : Style.SearchButton

  return (
    <>
      <div className={Style.SearchConditionRegularDate}>
        <div className={Style.SearchConditionFilterRow}>
          <div className={Style.SearchConditionFilterRowCell}>
            {weeks.map((week: WeekType) => {
              const work_time_from = (watch(
                `regular_search.${week}_work_time_from`,
              ) || '') as string
              const work_time_to = (watch(
                `regular_search.${week}_work_time_to`,
              ) || '') as string
              const work_time_from_unselected = (watch(
                `regular_search.${week}_work_time_from_unselected`,
              ) || 0) as number
              const work_time_to_unselected = (watch(
                `regular_search.${week}_work_time_to_unselected`,
              ) || 0) as number
              return (
                <div className={Style.SearchConditionWeeks} key={week}>
                  <input
                    type="hidden"
                    name={`regular_search[start_hour_${week}]`}
                    value={work_time_from.slice(0, 2)}
                  />
                  <input
                    type="hidden"
                    name={`regular_search[start_min_${week}]`}
                    value={work_time_from.slice(3, 5)}
                  />
                  <input
                    type="hidden"
                    name={`regular_search[end_hour_${week}]`}
                    value={work_time_to.slice(0, 2)}
                  />
                  <input
                    type="hidden"
                    name={`regular_search[end_min_${week}]`}
                    value={work_time_to.slice(3, 5)}
                  />
                  <input
                    type="hidden"
                    name={`regular_search[${week}_work_time_from_unselected]`}
                    value={work_time_from_unselected}
                  />
                  <input
                    type="hidden"
                    name={`regular_search[${week}_work_time_to_unselected]`}
                    value={work_time_to_unselected}
                  />
                  <div className={Style.SearchConditionFilterWeek}>
                    <input
                      className={Style.SearchConditionFilterWeekCtrl}
                      type="checkbox"
                      {...register(`regular_search.${week}`)}
                      name={`regular_search[${week}]`}
                      id={`left-search${
                        week.charAt(0).toUpperCase() + week.slice(1)
                      }`}
                      checked={!!watch(`regular_search.${week}`)}
                      onChange={(e) => {
                        setWeekHandler(`${week}`, e.target.checked ? 1 : 0)
                      }}
                      value={1}
                    />
                    <label
                      htmlFor={`left-search${
                        week.charAt(0).toUpperCase() + week.slice(1)
                      }`}
                      className={Style.SearchConditionFilterWeekLabel}
                    >
                      <span className={Style.SearchConditionFilterWeekCheck}>
                        <CheckIcon
                          className={Style.SearchConditionFilterWeekCheckIcon}
                        />
                      </span>
                      {t(`search:params.regularSearchWeek.${week}`)}
                    </label>
                  </div>
                  <ul className={Style.SearchTimeInput}>
                    <li className={Style.SearchTimeSelecter}>
                      <label className={Style.SearchTimeSelecterLabel}>
                        開始
                      </label>
                      <div>
                        {(() => {
                          const timeFrom: string =
                            work_time_from || DEFAULT_START_HOUR
                          return (
                            <TimePicker
                              label={
                                !work_time_from
                                  ? `${DEFAULT_START_HOUR}:${DEFAULT_START_MINUTE}`
                                  : timeFrom
                              }
                              defaultHour={timeFrom.slice(0, 2)}
                              defaultMinute={timeFrom.slice(3, 5)}
                              setTimeHandler={(value) =>
                                setWorkTimeFromHandler(week, value)
                              }
                            />
                          )
                        })()}
                      </div>

                      <div className={Style.SearchConditionFilterDay}>
                        <input
                          type="checkbox"
                          className={Style.SearchConditionFilterDayCtrl}
                          {...register(
                            `regular_search.${week}_work_time_from_unselected`,
                          )}
                          name={`regular_search[${week}_work_time_from_unselected]`}
                          id={`left-search${
                            week.charAt(0).toUpperCase() +
                            week.slice(1) +
                            'WorkTimeFromUnselected'
                          }`}
                          checked={!!work_time_from_unselected}
                          onChange={(e) =>
                            setWorkTimeFromUnselectedHandler(
                              week,
                              e.target.checked ? 1 : 0,
                            )
                          }
                          value={1}
                        />
                        <label
                          htmlFor={`left-search${
                            week.charAt(0).toUpperCase() +
                            week.slice(1) +
                            'WorkTimeFromUnselected'
                          }`}
                          className={Style.SearchConditionFilterDayLabel}
                        >
                          <span className={Style.SearchConditionFilterDayCheck}>
                            <CheckIcon
                              className={
                                Style.SearchConditionFilterDayCheckIcon
                              }
                            />
                          </span>
                          指定無し
                        </label>
                      </div>
                    </li>
                    <li className={Style.SearchTimeBetweenLabel}>～</li>
                    <li className={Style.SearchTimeSelecter}>
                      <label className={Style.SearchTimeSelecterLabel}>
                        終了
                      </label>
                      <div>
                        {(() => {
                          const timeTo: string = (watch(
                            `regular_search.${week}_work_time_to`,
                          ) || DEFAULT_END_HOUR) as string
                          return (
                            <TimePicker
                              label={
                                !watch(`regular_search.${week}_work_time_to`)
                                  ? `${DEFAULT_END_HOUR}:${DEFAULT_END_MINUTE}`
                                  : timeTo
                              }
                              defaultHour={timeTo.slice(0, 2)}
                              defaultMinute={timeTo.slice(3, 5)}
                              setTimeHandler={(value) =>
                                setWorkTimeToHandler(week, value)
                              }
                            />
                          )
                        })()}
                      </div>

                      <div className={Style.SearchConditionFilterDay}>
                        <input
                          type="checkbox"
                          className={Style.SearchConditionFilterDayCtrl}
                          {...register(
                            `regular_search.${week}_work_time_to_unselected`,
                          )}
                          name={`regular_search[${week}_work_time_to_unselected]`}
                          id={`left-search${
                            week.charAt(0).toUpperCase() +
                            week.slice(1) +
                            'WorkTimeToUnselected'
                          }`}
                          checked={!!work_time_to_unselected}
                          onChange={(e) =>
                            setWorkTimeToUnselectedHandler(
                              week,
                              e.target.checked ? 1 : 0,
                            )
                          }
                          value={1}
                        />
                        <label
                          htmlFor={`left-search${
                            week.charAt(0).toUpperCase() +
                            week.slice(1) +
                            'WorkTimeToUnselected'
                          }`}
                          className={Style.SearchConditionFilterDayLabel}
                        >
                          <span className={Style.SearchConditionFilterDayCheck}>
                            <CheckIcon
                              className={
                                Style.SearchConditionFilterDayCheckIcon
                              }
                            />
                          </span>
                          指定無し
                        </label>
                      </div>
                    </li>
                  </ul>
                  {!!watch(`regular_search.${week}`) == true &&
                    work_time_from >= work_time_to &&
                    !work_time_from_unselected &&
                    !work_time_to_unselected && (
                      <div className={Style.DateErrorMessage}>
                        開始時間と終了時間を正しく指定してください
                      </div>
                    )}
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <input
        type="submit"
        name="commit"
        value="定期を検索"
        className={buttonStyle}
        data-disable-with="定期を検索"
        disabled={isSearchDisable || undefined}
      ></input>
    </>
  )
}
